import {TEXT} from '@drivesally/sally-fw/lib/inputTypes';

// Attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

export default attribute({
  type: TEXT,
  attribute: 'gas_slack_channel',
  label: {
    default: 'GAS slack channel',
    short: 'GAS',
  },
});
